// extracted by mini-css-extract-plugin
export default {"FakeCard":"MasonryCard_FakeCard__PGMz6","FakeCard__wrap":"MasonryCard_FakeCard__wrap__zY-aD","MasonryCard__fav":"MasonryCard_MasonryCard__fav__vnt8T"};